import axios from 'axios'

export default {
  /**
   * Public menu (no auth) — used by the header, not the admin editor.
   */
  getPublic () {
    return axios.get('/api/mega-menu')
  },

  /**
   * Promo preset catalogue, grouped by column count. Served rather than
   * duplicated in JS so the unconfirmed catalogue stays single-source in
   * config/mega-menu.php.
   */
  getLayouts () {
    return axios.get('/api/admin/mega-menu/layouts')
  },

  /**
   * Navigation list for the editor.
   */
  getAll () {
    return axios.get('/api/admin/mega-menu')
  },

  /**
   * One item plus its promo images, side-loaded.
   */
  getById (id) {
    return axios.get(`/api/admin/mega-menu/${id}/show`)
  },

  /**
   * "+ Add Nav Item" sends a label only.
   */
  create (data) {
    return axios.post('/api/admin/mega-menu', data)
  },

  /**
   * Whole item — settings, columns and promo pane — in one atomic write.
   */
  update (id, data) {
    return axios.put(`/api/admin/mega-menu/${id}/update`, data)
  },

  delete (id) {
    return axios.delete(`/api/admin/mega-menu/${id}/destroy`)
  },

  /**
   * Clone a whole nav item, including its own copies of the promo images.
   */
  duplicate (id) {
    return axios.post(`/api/admin/mega-menu/${id}/duplicate`)
  },

  /**
   * Drag reorder. Position is the array index; sort_order is server-assigned.
   */
  updateOrder (ids) {
    return axios.post('/api/admin/mega-menu/update-order', { ids })
  },

  uploadImage (formData) {
    return axios.post('/api/admin/mega-menu/images', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  cropImage (id, crop) {
    return axios.patch(`/api/admin/mega-menu/images/${id}/crop`, { crop })
  },

  deleteImage (id) {
    return axios.delete(`/api/admin/mega-menu/images/${id}`)
  }
}
